import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
// import Notification from "rc-notification";
import axios from "axios";
import { ModalUsePortal } from "../../components/ModalUsePortal";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import "./styles.less";
import { tryNow, tryNowRegister } from "../../utils";
import { partnerInfo } from "../../utils/partnerInfo";

export const PartnerForm = (props) => {
  const { visible, setVisible } = props;
  const { handleSubmit, register, errors, reset, getValues } = useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [showNotice, setShowNotice] = useState(false);

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      await partnerInfo(values);

      // if (res.code === 200) {
      // setVisible(false);

      setLoading(false);
      setShowNotice(true);
      reset();
      // }
    } finally {
      // setVisible(false);
      setLoading(false);
      setShowNotice(true);
    }
  };

  const onError = (errors, e) => {
    console.log(errors);
  };

  const notice = () => {
    return (
      <div className="notice-block">
        <div className="notice-title">{t("common.form.success-tip")}</div>

        <div className="notice-img">
          <img
            src="//files.authing.co/authing-website/consult-form-img.png"
            alt="authing"
          />
        </div>
        <div className="notice-img-tip">
          {t("common.form.success-wait-tip")}
        </div>
      </div>
    );
  };
  const form = () => {
    return (
      <div className="partner-form">
        <div className="form-title">{t("partner.form.title")}</div>
        <div className="form-warp">
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="form-item">
              <div className="input">
                <Input
                  name="company"
                  error={errors.company}
                  placeholder={t("partner.form.company")}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^[^\s]*$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="input">
                <Input
                  name="email"
                  placeholder={t("partner.form.email")}
                  inputRef={register()}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="input">
                <Input
                  name="address"
                  error={errors.address}
                  placeholder={t("partner.form.address")}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^[^\s]*$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="input">
                <Input
                  error={errors.name}
                  placeholder={t("partner.form.name")}
                  name="name"
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^[^\s]*$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="input">
                <Input
                  name="phone"
                  error={errors.phone}
                  placeholder={t("partner.form.phone")}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^1[3-9]\d{9}$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>

            <div className="form-item">
              <div className="input">
                <Input
                  name="intend"
                  placeholder={t("partner.form.intend")}
                  error={errors.intend}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^[^\s]*$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <Button
                type="submit"
                className="consult-submit"
                disabled={loading}
              >
                {loading ? (
                  <ReactLoading
                    type={"spin"}
                    height={20}
                    width={20}
                    delay={0}
                    className={"spin-loading"}
                  />
                ) : (
                  ""
                )}
                {t("common.form.submit")}
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  return <div>{showNotice ? notice() : form()}</div>;
};
